import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ProfilPage } from './pages/ProfilPage';
import { LayananPage } from './pages/LayananPage';
import { TataKelolaPage } from './pages/TataKelolaPage';
import { KeterbukaanInformasiPage } from './pages/KeterbukaanInformasiPage';
import { ProyekPage } from './pages/ProyekPage';
import { KontakPage } from './pages/KontakPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={setCurrentPage} data-id="element-0" />;
      case 'profil':
        return <ProfilPage data-id="element-1" />;
      case 'layanan':
        return <LayananPage data-id="element-2" />;
      case 'tata-kelola':
        return <TataKelolaPage data-id="element-3" />;
      case 'keterbukaan':
        return <KeterbukaanInformasiPage data-id="element-4" />;
      case 'proyek':
        return <ProyekPage data-id="element-5" />;
      case 'kontak':
        return <KontakPage data-id="element-6" />;
      default:
        return <HomePage onNavigate={setCurrentPage} data-id="element-7" />;
    }
  };
  return <Layout currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-8">
      {renderPage()}
    </Layout>;
}